var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-cascader',{staticClass:"w100f",attrs:{"options":_vm.options,"props":{ checkStrictly: false }},on:{"change":_vm.handleChange},model:{value:(_vm.workarea),callback:function ($$v) {_vm.workarea=$$v},expression:"workarea"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }